'use client'

import { FC, Fragment } from 'react'

import { Form } from './components'
import { IFirstAccessProps } from './types'

const FirstAccess: FC<IFirstAccessProps> = ({ isFirstAccess, children }) => {
  return (
    <>
      {isFirstAccess ? (
        <>
          <Form />

          {children}
        </>
      ) : (
        children
      )}
    </>
  )
}

export default FirstAccess
